module.exports = __webpack_public_path__ + "fa58e915642e9f2beb678c69f4507564.png";